export default __webpack_public_path__ + "static/media/simgecan6.d9afac7c.jpg";